// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Kv-z","tooltipWrapper":"Lv-z","icon":"Mv-z","tooltip":"Nv-z","content":"Ov-z"};